import ContractABI from '../artifacts/ContractABI.json';
import AppConfig from 'config/config';
import { BigNumber, ethers } from 'ethers';

export const getWalletTokenBalance = async (
  walletAddress: string,
  web3Provider: ethers.providers.Web3Provider | null,
  tokenAddress: string = AppConfig.PAPER_TOKEN_CONTRACT_ADDRESS,
) => {
  const signer = web3Provider?.getSigner();
  const contract = new ethers.Contract(
    tokenAddress,
    ['function balanceOf(address account) external view returns (uint256)'],
    signer,
  );

  try {
    const totalTokens = await contract.balanceOf(walletAddress);

    return {
      totalTokens,
      error: false,
    };
  } catch (err: any) {
    return {
      error: true,
      errorMessage: err.data && err.data.message ? err.data.message : 'Error fetching token balance',
      totalTokens: 0,
    };
  }
};

export const itemRecallRequest = async (
  web3Provider: ethers.providers.Web3Provider | null,
  signature: string,
  itemIds: Array<number>,
  quantity: Array<number>,
  contractAddress: string = AppConfig.MARKETPLACE_CONTRACT_ADDRESS,
) => {
  const signer = web3Provider?.getSigner();
  const contract = new ethers.Contract(contractAddress, ContractABI.abi, signer);

  const tx = await contract.reclaimBids(signature, itemIds, quantity);

  return {
    success: true,
    tx,
  };
};

export const buyItem = async (
  web3Provider: ethers.providers.Web3Provider | null,
  itemId: number,
  signature: string,
  quantity: number,
  buyPricePaper: string,
  buyPriceEth: string,
  maxAllowedQuantity: number,
  contractAddress: string = AppConfig.MARKETPLACE_CONTRACT_ADDRESS,
) => {
  const signer = web3Provider?.getSigner();
  const contract = new ethers.Contract(contractAddress, ContractABI.abi, signer);

  const tx = await contract.buy(
    signature,
    itemId,
    quantity,
    ethers.utils.parseEther((parseFloat(buyPricePaper) * quantity).toString()),
    ethers.utils.parseEther((parseFloat(buyPriceEth) * quantity).toString()),
    maxAllowedQuantity,
    {
      value: ethers.utils.parseEther((parseFloat(buyPriceEth) * quantity).toString()),
    },
  );

  return {
    success: true,
    tx,
  };
};

export const bidItem = async (
  web3Provider: ethers.providers.Web3Provider | null,
  itemId: number,
  signature: string,
  bidAmount: string,
  bidQuantity: number,
  contractAddress: string = AppConfig.MARKETPLACE_CONTRACT_ADDRESS,
) => {
  const signer = web3Provider?.getSigner();
  const contract = new ethers.Contract(contractAddress, ContractABI.abi, signer);

  const tx = await contract.bid(signature, itemId, ethers.utils.parseEther(bidAmount), bidQuantity);

  return {
    success: true,
    tx,
  };
};

export const checkTokenAllowance = async (
  walletAddress: string,
  web3Provider: ethers.providers.Web3Provider | null,
  tokenAddress: string = AppConfig.PAPER_TOKEN_CONTRACT_ADDRESS,
  contractAddress: string = AppConfig.MARKETPLACE_CONTRACT_ADDRESS,
) => {
  try {
    const signer = web3Provider?.getSigner();
    const contract = new ethers.Contract(
      tokenAddress,
      ['function allowance(address owner, address spender) external view returns (uint256)'],
      signer,
    );

    const allowance = await contract.allowance(walletAddress, contractAddress);

    return {
      success: true,
      allowance,
    };
  } catch (err: any) {
    return {
      error: true,
      errorMessage: err.data && err.data.message ? err.data.message : 'Error fetching allowance',
    };
  }
};

export const approveToken = async (
  web3Provider: ethers.providers.Web3Provider | null,
  tokenAddress: string = AppConfig.PAPER_TOKEN_CONTRACT_ADDRESS,
  contractToApprove: string = AppConfig.MARKETPLACE_CONTRACT_ADDRESS,
) => {
  try {
    const signer = web3Provider?.getSigner();
    const contract = new ethers.Contract(
      tokenAddress,
      ['function approve(address spender, uint256 amount) external returns (bool)'],
      signer,
    );

    const maxInt = BigNumber.from('2').pow(BigNumber.from('256')).sub(BigNumber.from('1'));
    const tx = await contract.approve(contractToApprove, maxInt);

    return {
      success: true,
      tx,
    };
  } catch (err: any) {
    return {
      error: true,
      errorMessage: err.data && err.data.message ? err.data.message : err.message,
    };
  }
};
